import React from 'react';

import SwiperCore, { Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import 'swiper/swiper.scss';
import 'swiper/modules/pagination/pagination.scss';
import 'swiper/modules/autoplay/autoplay.scss';

import styled from 'styled-components';

SwiperCore.use([Pagination, Autoplay]);

export default function HistorySlider() {
  return (
    <StyledHistorySlider>
      <Swiper {...settings}>
        {HISTORY_IMAGES.map(({ id, src }) => (
          <SwiperSlide key={id}>
            <StyledHistoryImage alt="history image" src={src} />
          </SwiperSlide>
        ))}
      </Swiper>
    </StyledHistorySlider>
  );
}

const StyledHistorySlider = styled(SwiperSlide)`
  display: none;

  ${({ theme }) => theme.mobile`
    display: block;
  `}

  .swiper-slide .swiper-container {
    position: static;
  }

  .swiper-pagination {
    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background-color: ${({ theme: { colors } }) => colors.white};
      transition: all 0.3s;
    }

    .swiper-pagination-bullet-active {
      width: 35px;
      background-color: ${({ theme: { colors } }) => colors.green};
      border-radius: 10px;
      transition: all 1s;
    }
  }
`;

const StyledHistoryImage = styled.img`
  width: 225px;
  padding-bottom: 50px;
  margin: 0 auto;
`;

const settings = {
  className: 'swiper-container',
  slidesPerView: 1,
  navigation: true,
  pagination: { clickable: true },
  scrollbar: { draggable: true },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  speed: 1000,
  loop: true,
};

const HISTORY_IMAGES = [
  {
    id: 1,
    src: 'images/Home/history/2021/group-17@3x.png',
  },
  {
    id: 2,
    src: 'images/Home/history/2018/group-13@3x.png',
  },
  {
    id: 3,
    src: 'images/Home/history/2017/group-13@3x.png',
  },
  {
    id: 4,
    src: 'images/Home/history/2016/group-14@3x.png',
  },
];
